import React from "react";
import {
    ButtonHistory,
    ButtonPlayPause,
    ButtonQualityOrVolumeContainer,
    ButtonSpeaker,
    CustomReactPlayer,
    Image,
    OverlayPlay,
    OverlayQuality,
    OverlayHistory,
    WithoutLogoClassStyle, HistoryExtended, updatePlayerRatio, Skeleton,
} from '../../helpers/rendererHelper'
import "./PlayerSmall.css";
import Player from "./Player";

export default class PlayerSmall extends Player {
    render() {
        const {
            author,
            backgroundColor,
            buttonColor,
            bufferDuration,
            defaultVolume,
            display,
            fragment,
            historyHold,
            historyDisplay,
            isHistoryTimeDisplay,
            isHistoryClickable,
            light,
            isDirectControl,
            isHlsBuffered,
            logo,
            main,
            muted,
            neverPlayed,
            playbackRate,
            playing,
            playlist,
            previousPlayTime,
            secondaryColor,
            stream,
            streams,
            timeline,
            timelineLoaded,
            title,
            translations,
            unavailableUrl,
            url,
            volume,
            preview
        } = this.state;

        const showPlayer = !!stream;
        const color = {backgroundColor: backgroundColor, color: secondaryColor};

        document.body.style.backgroundColor = backgroundColor;

        if (historyDisplay === 'under') {
            updatePlayerRatio(2.66, 1.6);
        } else {
            updatePlayerRatio(1, 0.73);
        }
        return <>
            <Skeleton hidden={showPlayer}></Skeleton>

            {showPlayer &&
                <>
                    <div className='player-wrapper small-player' style={color}>
                        <OverlayQuality addTitle={false} streams={streams} stream={stream} main={main}
                                        translations={translations} buttonColor={buttonColor} backgroundColor={backgroundColor}
                                        onClickClose={this.handleCloseOverlay}
                                        load={this.load}/>
                        <OverlayHistory visible={historyDisplay === 'overlay'} timeline={timeline} historyHold={historyHold}
                                        timeColor={secondaryColor} isDirectControl={isDirectControl} timelineLoaded={timelineLoaded}
                                        currentTrack={title} streamFormat={stream?.format} isHlsBuffered={isHlsBuffered}
                                        backgroundColor={backgroundColor} buttonColor={buttonColor} currentTime={previousPlayTime}
                                        showTimecode={isHistoryTimeDisplay} allowTimeshift={isHistoryClickable} playing={playing}
                                        fragment={fragment} playlist={playlist} preview={preview} bufferSize={bufferDuration}
                                        onClickClose={this.handleCloseOverlay} onClick={this.handleSeekTo} type="overlay"/>
                        <div id="player-image">
                            <OverlayPlay onClickPlay={this.handlePlay} onClickPause={this.handlePause} buttonColor={buttonColor} playing={playing}
                                         backgroundColor={backgroundColor} neverPlayed={neverPlayed}/>
                            <Image display={display} onLoad={this.onLoadImage} color={secondaryColor} buttonColor={buttonColor}
                                   neverPlayed={neverPlayed} translations={translations}/>
                        </div>
                        <div id="player">
                            <div className="button-history-title">
                                <div id="title-container" className="text-fade"><p id="title">{title}</p></div>
                                <ButtonHistory visible={historyDisplay === 'overlay'} color={buttonColor} onClick={this.handleOpenOverlay}/>
                            </div>
                            <div id="author-container" className="text-fade"><p id="author">{author}</p></div>
                            <div id="controls" className={WithoutLogoClassStyle(logo)}>
                                <div id="player-buttons" className="buttons">
                                    <ButtonPlayPause
                                        onClickPlay={this.handlePlay}
                                        onClickPause={this.handlePause}
                                        color={buttonColor}
                                        playing={playing}
                                    />
                                    <ButtonSpeaker
                                        onClick={this.handleToggleMuted}
                                        color={buttonColor}
                                        muted={muted}
                                    />
                                    <ButtonQualityOrVolumeContainer visible={streams.length > 1} color={buttonColor}
                                                                    volume={volume}
                                                                    defaultVolume={defaultVolume}
                                                                    onClick={this.handleOpenOverlay}
                                                                    onChange={this.handleVolumeChange}/>
                                </div>
                                <a id="logo" target="_blank" href="https://infomaniak.com">
                                    <p id="powered-by">by</p>
                                    <p id="infomaniak">infomaniak</p>
                                </a>
                            </div>
                        </div>
                        <CustomReactPlayer
                            myRef={this.ref}
                            url={url}
                            playing={playing}
                            light={light}
                            playbackRate={playbackRate}
                            volume={volume}
                            muted={muted}
                            neverPlayed={neverPlayed}
                            playlist={playlist}
                            fragment={fragment}
                            unavailableUrl={unavailableUrl}
                            onReady={this.onPlayerReady}
                            onProgress={this.handleProgress}
                            setPlayerInError={this.setPlayerInError}
                            preview={preview}
                        />
                    </div>

                    {historyDisplay === 'under' &&
                        <HistoryExtended timeline={timeline} timeColor={secondaryColor}
                                         textColor={buttonColor} isDirectControl={isDirectControl}
                                         currentTrack={title} streamFormat={stream?.format}
                                         fragment={fragment} playlist={playlist}
                                         currentTime={previousPlayTime}
                                         isHlsBuffered={isHlsBuffered} timelineLoaded={timelineLoaded}
                                         backgroundColor={backgroundColor} historyHold={historyHold}
                                         playing={playing} historyDisplay={historyDisplay}
                                         onClick={this.handleSeekTo} type="extended" preview={preview}
                                         showTimecode={isHistoryTimeDisplay}
                                         bufferSize={bufferDuration}
                                         allowTimeshift={isHistoryClickable}/>
                    }
                </>
            }
        </>;
    }
}
